export default "__VITE_ASSET__DAmCzxCd__"